import { createContext } from "react";

const UserContext = createContext({
  auth: {},
  setAuth: (prevAuth) => ({}),
  instance: {}
});

export default UserContext;